import { render, staticRenderFns } from "./ContactPhoneEmail.vue?vue&type=template&id=fef0653e"
import script from "./ContactPhoneEmail.vue?vue&type=script&lang=js"
export * from "./ContactPhoneEmail.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports